import { MileStoneTitleMap, MilestoneTypes } from '@/constants';
import type { goalType } from '@/types';
import { capitaliseFirstLetter } from './string';

export const formatGiftTitle = ({
  goalType,
  customTitle = '',
}: {
  goalType: goalType;
  customTitle?: string;
}): string => {
  if (goalType === MilestoneTypes.other) {
    return capitaliseFirstLetter(customTitle);
  }
  return capitaliseFirstLetter(MileStoneTitleMap[goalType] || 'Future');
};
